import { render, staticRenderFns } from "./ProductsReport.vue?vue&type=template&id=197cbbda&scoped=true"
import script from "./ProductsReport.vue?vue&type=script&lang=js"
export * from "./ProductsReport.vue?vue&type=script&lang=js"
import style0 from "./ProductsReport.vue?vue&type=style&index=0&id=197cbbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197cbbda",
  null
  
)

export default component.exports